import { REGEX } from "core/config/constant";
import * as Yup from "yup";

export const mergeObjects = (...objects: any) => {
  return objects.reduce((acc: any, obj: any) => ({ ...acc, ...obj }), {});
};

export const validationEmail = {
  email: Yup.string()
    .matches(REGEX.EMAIL, "auth.AU_02_MSG_01")
    .required("auth.AU_02_MSG_01"),
};

export const validationPassword = (msg?: string) => {
  if (!msg) {
    msg = "auth.AU_02_MSG_05";
  }
  return {
    password: Yup.string().matches(REGEX.PASSWORD, msg).required(msg),
  };
};

export const validationRePassword = {
  rePassword: Yup.string().oneOf(
    [Yup.ref("password")],
    "auth.AU_02_MSG_06"
  )
  .required("auth.AU_02_MSG_06"),
};

export const validationSchemaLogin = Yup.object().shape(
  mergeObjects(
    validationEmail
    // validationPassword
  )
);
export const validationSchemaForm = Yup.object().shape(
  mergeObjects(validationEmail, validationPassword(), validationRePassword)
);
export const validationSchemaForgotCheckMail =
  Yup.object().shape(validationEmail);

export const validationSchemaConfirmPassword = Yup.object().shape(
  mergeObjects(validationPassword('auth.MI_02_MSG_01'))
);

export const validationSchemaChangePassword = Yup.object().shape(
  mergeObjects(validationPassword(), validationRePassword)
);

export const validationSchemaRequestPassword = Yup.object().shape(
  validationPassword()
);

export const validationSchemaConfirmPasswordToLeave = Yup.object().shape(
	mergeObjects(validationPassword('auth.MI_02_MSG_01')
));

